import React from "react";

const Access_Specifiers = () => {
  return (
    <div>
      <h1>Access_Specifiers Component</h1>
      <p>Content for Access_Specifiers goes here...</p>
    </div>
  );
};

export default Access_Specifiers;
